import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import Icon from '../Icon';
import StackView from '../StackView';
import Text from '../Text';

var DayStatus = function DayStatus(_ref) {
  var color = _ref.color,
      restProps = _objectWithoutPropertiesLoose(_ref, ["color"]);

  return /*#__PURE__*/React.createElement(Icon.Status, _extends({
    size: "5px",
    color: color
  }, restProps));
};

var Day = function Day(_ref2) {
  var backgroundColor = _ref2.backgroundColor,
      cellSize = _ref2.cellSize,
      children = _ref2.children,
      color = _ref2.color,
      date = _ref2.date,
      disabled = _ref2.disabled,
      fontSize = _ref2.fontSize,
      fontWeight = _ref2.fontWeight,
      inSameMonth = _ref2.inSameMonth,
      isMinDate = _ref2.isMinDate,
      isMaxDate = _ref2.isMaxDate,
      isSelected = _ref2.isSelected,
      isToday = _ref2.isToday,
      selectDate = _ref2.selectDate,
      _ref2$selectedColor = _ref2.selectedColor,
      selectedColor = _ref2$selectedColor === void 0 ? 'primary' : _ref2$selectedColor,
      _ref2$statusColor = _ref2.statusColor,
      statusColor = _ref2$statusColor === void 0 ? 'transparent' : _ref2$statusColor,
      statuses = _ref2.statuses,
      restProps = _objectWithoutPropertiesLoose(_ref2, ["backgroundColor", "cellSize", "children", "color", "date", "disabled", "fontSize", "fontWeight", "inSameMonth", "isMinDate", "isMaxDate", "isSelected", "isToday", "selectDate", "selectedColor", "statusColor", "statuses"]);

  var affordance = !disabled && !isMinDate && !isMaxDate && (selectDate || restProps.onClick || restProps.onMouseDown);
  return /*#__PURE__*/React.createElement(StackView, {
    width: cellSize,
    height: cellSize,
    position: "relative",
    userSelect: "none",
    backgroundColor: backgroundColor,
    color: color,
    cursor: affordance ? 'pointer' : 'default',
    onClick: function onClick() {
      return selectDate && !disabled && !isMinDate && !isMaxDate && selectDate(date);
    }
  }, /*#__PURE__*/React.createElement(StackView, _extends({
    width: "100%",
    height: "100%",
    alignment: "center",
    distribution: "center",
    pointerEvents: (disabled || isMinDate || isMaxDate) && 'none',
    hover: affordance && {
      backgroundColor: 'highlight'
    }
  }, restProps), (isSelected || isToday || statusColor) && /*#__PURE__*/React.createElement(Icon.Status, {
    size: cellSize,
    color: isSelected ? selectedColor : isToday ? 'surfaceTertiary' : statusColor,
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)"
  }), /*#__PURE__*/React.createElement(Text, {
    as: "span",
    fontSize: fontSize,
    fontWeight: fontWeight,
    lineHeight: 2,
    position: "relative"
  }, date.getDate()), statuses && /*#__PURE__*/React.createElement(StackView, {
    axis: "horizontal",
    distribution: "center",
    position: "absolute",
    bottom: "15%",
    left: 0,
    right: 0,
    spacing: 0.25
  }, statuses.map(function (color, index) {
    return /*#__PURE__*/React.createElement(DayStatus, {
      key: index,
      color: isSelected ? 'white' : color
    });
  }))));
};

export default Day;